module.exports = __webpack_public_path__ + "static/media/gesmedia.a205112f.png";